/*
 * This dirctive was found on https://stackoverflow.com/a/48117566
 * With this directive we can make dynamic backend driven links
 * (from about-us to contact e.g.)
 */
import { Directive, ElementRef, HostListener } from '@angular/core';
import { Router } from '@angular/router';

@Directive({
  selector: '[routeDirective]'
})

export class RouteDirective {

  constructor(private el: ElementRef, private router: Router) { }

  @HostListener('click', ['$event.target']) onClick($event){
    var goRoute = $event.getAttribute('href');
    if (goRoute && goRoute.startsWith("/")) {
      this.router.navigate(goRoute.split("/"));
      return false;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/Directives/route.directive.ts